import classnames from 'classnames';
import React, { type RefObject } from 'react';
import styles from './MenuItemComponent.module.css';
import { type ReferenceAhaObject } from '@aha-app/aha-editor-v2';

const MenuItemComponent = React.forwardRef<HTMLElement | null, any>(
  function menuItemComponentWithRef(
    { item }: { item: ReferenceAhaObject },
    ref
  ) {
    const { name, context } = item;

    return (
      <div
        className={classnames(styles.menuItemComponent, {
          [styles.menuItemComponentWithContext]: Boolean(context),
        })}
        ref={ref as RefObject<HTMLDivElement>}
      >
        <div>{name}</div>
        {context && (
          <div
            className={classnames(
              styles.menuItemComponentContext,
              't-200 color-tertiary'
            )}
          >
            {context}
          </div>
        )}
      </div>
    );
  }
);

export default MenuItemComponent;
